import { render, staticRenderFns } from "./evaluacion-indicadores.vue?vue&type=template&id=408d132c&"
import script from "./evaluacion-indicadores.vue?vue&type=script&lang=js&"
export * from "./evaluacion-indicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports